<template>
  <div class="transfer">
    <div class="transfer__inner">
      <div class="transfer__header">
        <div
          v-for="(tab, i) in tabs"
          :key="i"
          :class="['transfer__tab', {'active': (i === selectedIndex)}]"
          @click="selectTab(i)"
        >
          {{tab.title}}
        </div>
      </div>
      <div class="transfer__body">
        <div
          :class="['transfer__refill',
                   'transfer__item',
                   {'transfer__item--active': selectedIndex === 0}]"
        >
          <refill />
        </div>
        <div
          :class="['transfer__bank-transfer',
                   'transfer__item',
                   {'transfer__item--active': selectedIndex === 1}]"
        >
          <bank-transfer />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import BankTransfer from './BankTransfer.vue';
import BankTransferMerchant from './BankTransferMerchant.vue';
import { useStore } from 'vuex';

import Refill from './Refill.vue';

export default defineComponent({
  components: {
    Refill,
    BankTransfer,
    BankTransferMerchant
  },
  setup() {
    let  selectedIndex = ref(0);
    const store = useStore();
 
    const tabs = ref([
      {
        title: 'На баланc телефона',
      },
      {
        title: 'Нa банковскую карту',
      }
    ]);

    const selectTab = (index: number) => selectedIndex.value = index;
    const isDefault = computed(() => store.getters['isDefault']);
    
    return {
      tabs,
      selectedIndex,
      selectTab,
      isDefault
    };
  },
});
</script>
<style lang="scss" scoped>
.transfer{
    &__header{
        display: flex;
        margin-bottom: 16px;
    }
    &__item{
        flex: 1;
        display: none;
    }
    &__item--active{
        display: block;
    }
    &__tab{
        flex: 1;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        text-align: center;
        padding: 12px 0 10px 0;
        border-bottom: 2px solid transparent;
    }
    &__tab:first-child{
        padding-right: 8px;
    }

    &__tab:last-child{
        padding-left: 8px;
    }
}
.default{
    .active{
        border-color: $primary-purple;
        color: $primary-purple;
    }
}
.tele2{
    .active{
        border-color: $secondary-blue;
        color:  $secondary-blue;
    }
}
.altel{
    .active{
        border-color: $primary-pink;
        color: $primary-pink;
    }
}
@media (min-width:641px)  { 
    .transfer{
        &__header{
            display: none;
        }
        &__body{
            display: flex;
            gap: 24px;
        }
        &__item{
            display: block;
        }
    }
}
</style>
